import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/config/app.config';
import { initializeMonitoring } from './app/config/app.config.monitoring';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// initializeMonitoring();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
